<template>
    <form class="mt-5">
        <div class="text-center" v-if="isLoading" >
            <loader width="5rem"></loader>
        </div>
        <div v-else>
            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="generalConditions" v-model="form.generalConditions" :class="['custom-control-input', ($v.form.generalConditions.$dirty) ? ($v.form.generalConditions.$error) ?'is-invalid' : 'is-valid' : '']" required @change="$v.form.generalConditions.$touch">
                    <label class="custom-control-label" for="generalConditions">Ik ga akkoord met de <router-link tag="a" target="_blank" :to="{ name: 'GeneralConditions' }">Algemene Voorwaarden</router-link> van Azurtiy. <sup class="red" title="verplicht">*</sup></label>
                </div>
                <br>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="correctness" v-model="form.correctNess" :class="['custom-control-input', ($v.form.correctNess.$dirty) ? ($v.form.correctNess.$error) ?'is-invalid' : 'is-valid' : '']" required @change="$v.form.correctNess.$touch">
                    <label class="custom-control-label" for="correctness">Ik verklaar hierbij dat alle informatie naar waarheid en juistheid is ingevuld. Ik ben tevens op de hoogte dat bij het insturen van valse documentatie aangifte wordt gedaan. <sup class="red" title="verplicht">*</sup></label>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import Loader from '@/components/Loader'

const mustBeTrue = (value) => {
    if(value != null)
    {
        return value
    }
    return true;
};


export default {
    props: ['clickedNext', 'currentStep'],
    mixins: [validationMixin],
    components: {
        'loader': Loader
    },
    data() {
        return {
            isLoading: false,
            form: {
                generalConditions: false,
                correctNess: false
            },
        }
    },
    validations: {
        form: {
            generalConditions: {
                required,
                mustBeTrue
            },
            correctNess: {
                required,
                mustBeTrue
            }
        }
    },
    mounted() {
        this.getProfile().then(() => {
            this.isLoading = false;
            if(!this.$v.$invalid) {
                this.$emit('can-continue', {value: true});
            } else {
                this.$emit('can-continue', {value: false});
            }
            this.init = true;
        });
    },
    methods: {          
        getProfile() {
            this.isLoading = true;
            return this.$http.get('api/Profile/Client/Wizard/3').then((res) => 
            {
                this.form.generalConditions = res.data.generalConditions;
                this.form.correctNess = res.data.correctNess;
            }).catch(() => {
                this.isLoading = false;
            })
        },
        setProfile() {
            return new Promise((resolve, reject) => {
                this.isLoading = true;

                let formData = new FormData();
                for ( var key in this.form) {
                    formData.append(key, this.form[key])
                }
                
                return this.$http.post('api/Profile/Client/Wizard/3', formData).then(() => {
                    this.isLoading = false;
                    return resolve();
                }).catch((res) => {
                    this.isLoading = false;
                    return reject(res);
                    //alert('Oops, de laatste stap is niet goed opgeslagen!')
                })
            });
        }
    },
    computed: {
    },
    watch: {
        $v: {
            handler: function (val) {
                if(!val.$invalid) {
                    this.$emit('can-continue', {value: true});
                } else {
                    this.$emit('can-continue', {value: false});
                }
            },
            deep: true
        },
        clickedNext(val) {
            if(val === true) {
                this.$v.form.$touch();
            }
        }
    },
}
</script>

<style scoped>
label {
    display: inline-block !important;
}
label:not(.custom-control-label) {
    font-weight: bold;
}

</style>